<script>
export default {
    name: 'ComponentsFooter',
}
</script>
<template>
    <div class="d-flex flex-1 flex-column">
        <div class="d-flex flex-1 justify-content-center">
            <strong>Kontakt:</strong>&nbsp; biuro@akademiatakeda.pl
        </div>
        <footer>
            <div class="container">
                <div class="text-center">
                    Materiał dla personelu medycznego, przygotowany z inicjatywy i sponsorowany przez Takeda.<br />
                    MARv: VV-MEDMAT-87070; 05/2023<br />
                    Copyright &copy; {{ (new Date()).getFullYear() }} Takeda Pharmaceutical<br />
                    Company Limited.<br />
                    Wszystkie prawa zastrzeżone.<br />
                    Wszystkie znaki handlowe są własnościami ich prawowitych właścicieli.<br />
                </div>
            </div>
        </footer>
    </div>
</template>
